const initProductTabs = () => {
  document.querySelectorAll('[data-product-tabs]').forEach((tabsRoot) => {
    const triggers = Array.from(tabsRoot.querySelectorAll('[data-tab-trigger]'))
    const panels = Array.from(tabsRoot.querySelectorAll('[data-tab-panel]'))

    if (!triggers.length || !panels.length) {
      return
    }

    const activate = (key) => {
      triggers.forEach((trigger) => {
        const isActive = trigger.getAttribute('data-tab-trigger') === key
        trigger.classList.toggle('is-active', isActive)
        trigger.setAttribute('aria-selected', isActive ? 'true' : 'false')
      })

      panels.forEach((panel) => {
        const isActive = panel.getAttribute('data-tab-panel') === key
        panel.classList.toggle('is-active', isActive)
        panel.hidden = !isActive
      })
    }

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => activate(trigger.getAttribute('data-tab-trigger')))
    })
  })
}

const initProductGallery = () => {
  document.querySelectorAll('[data-product-gallery]').forEach((galleryRoot) => {
    const mainImage = galleryRoot.querySelector('[data-gallery-main-image]')
    const thumbButtons = Array.from(galleryRoot.querySelectorAll('[data-gallery-thumb]'))
    const singleRoot = galleryRoot.closest('[data-product-single]')
    const modal = singleRoot ? singleRoot.querySelector('[data-product-gallery-modal]') : null
    const modalImage = modal ? modal.querySelector('[data-gallery-modal-image]') : null
    const closeButtons = modal ? Array.from(modal.querySelectorAll('[data-gallery-close]')) : []
    const prevButton = modal ? modal.querySelector('[data-gallery-prev]') : null
    const nextButton = modal ? modal.querySelector('[data-gallery-next]') : null
    const openButton = galleryRoot.querySelector('[data-gallery-open]')

    if (!mainImage || !thumbButtons.length) {
      return
    }

    let activeIndex = Math.max(thumbButtons.findIndex((thumb) => thumb.classList.contains('is-active')), 0)

    const setActiveImage = (index) => {
      const nextIndex = thumbButtons[index] ? index : 0
      const activeThumb = thumbButtons[nextIndex]

      if (!activeThumb) {
        return
      }

      activeIndex = nextIndex
      const mainSrc = activeThumb.getAttribute('data-image-main') || ''
      const modalSrc = activeThumb.getAttribute('data-image-modal') || mainSrc
      const alt = activeThumb.getAttribute('data-image-alt') || ''

      mainImage.src = mainSrc
      mainImage.alt = alt

      if (modalImage) {
        modalImage.src = modalSrc
        modalImage.alt = alt
      }

      thumbButtons.forEach((thumb, thumbIndex) => {
        thumb.classList.toggle('is-active', thumbIndex === activeIndex)
      })
    }

    const openModal = () => {
      if (!modal) {
        return
      }

      modal.hidden = false
      document.body.classList.add('has-gallery-modal')
    }

    const closeModal = () => {
      if (!modal) {
        return
      }

      modal.hidden = true
      document.body.classList.remove('has-gallery-modal')
    }

    thumbButtons.forEach((thumb, index) => {
      thumb.addEventListener('click', () => setActiveImage(index))
    })

    if (openButton) {
      openButton.addEventListener('click', openModal)
    }

    closeButtons.forEach((button) => {
      button.addEventListener('click', closeModal)
    })

    if (prevButton) {
      prevButton.addEventListener('click', () => {
        const nextIndex = activeIndex === 0 ? thumbButtons.length - 1 : activeIndex - 1
        setActiveImage(nextIndex)
      })
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        const nextIndex = activeIndex === thumbButtons.length - 1 ? 0 : activeIndex + 1
        setActiveImage(nextIndex)
      })
    }

    document.addEventListener('keydown', (event) => {
      if (!modal || modal.hidden) {
        return
      }

      if (event.key === 'Escape') {
        closeModal()
      }

      if (event.key === 'ArrowLeft' && prevButton) {
        prevButton.click()
      }

      if (event.key === 'ArrowRight' && nextButton) {
        nextButton.click()
      }
    })

    setActiveImage(activeIndex)
  })
}

const initProductVariationStock = () => {
  document.querySelectorAll('[data-product-single]').forEach((singleRoot) => {
    const stockTarget = singleRoot.querySelector('[data-product-stock]')
    const variationsForm = singleRoot.querySelector('form.variations_form')

    if (!stockTarget || !variationsForm || typeof window.jQuery === 'undefined') {
      return
    }

    const $form = window.jQuery(variationsForm)
    const defaultStock = stockTarget.textContent.trim()

    const updateStock = (html) => {
      const wrapper = document.createElement('div')
      wrapper.innerHTML = html || ''
      const stockNode = wrapper.querySelector('.stock')
      const nextText = stockNode ? stockNode.textContent.trim() : ''

      if (nextText) {
        stockTarget.textContent = nextText
        stockTarget.hidden = false
      } else if (defaultStock) {
        stockTarget.textContent = defaultStock
        stockTarget.hidden = false
      } else {
        stockTarget.hidden = true
      }
    }

    $form.on('found_variation', (event, variation) => {
      updateStock(variation && variation.availability_html ? variation.availability_html : '')
    })

    $form.on('reset_data hide_variation', () => {
      if (defaultStock) {
        stockTarget.textContent = defaultStock
        stockTarget.hidden = false
      } else {
        stockTarget.hidden = true
      }
    })
  })
}

const initProductPurchaseLayout = () => {
  document.querySelectorAll('[data-product-purchase]').forEach((purchaseRoot) => {
    const wishlist = purchaseRoot.querySelector('[data-product-wishlist]')

    if (!wishlist) {
      return
    }

    let target = purchaseRoot.querySelector('.woocommerce-variation-add-to-cart, .variations_button')

    if (!target) {
      target = purchaseRoot.querySelector('form.cart:not(.variations_form)')
    }

    if (!target) {
      return
    }

    if (wishlist.parentElement !== target) {
      target.appendChild(wishlist)
    }
  })
}

const initProductSingle = () => {
  initProductTabs()
  initProductGallery()
  initProductVariationStock()
  initProductPurchaseLayout()
}

export default initProductSingle



// WEBPACK FOOTER //
// ./resources/assets/js/components/product-single.js